module.exports = __webpack_public_path__ + "media/images/icons/twotone/up-circle-ebf37c7705a5059761d8728538dfa10e.svg";